import { render, staticRenderFns } from "./current_status_canada.vue?vue&type=template&id=39e5be04&"
import script from "./current_status_canada.vue?vue&type=script&lang=js&"
export * from "./current_status_canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports